import numeral from "numeral"
import moment from "moment"
import twix from "twix"
import { accountsFromInstitutionUsers } from "./"

const B = str => `<b>${str}</b>`

const countObservedFields = rules => {
  // get all observedFields and count them
  function count(arr) {
    return arr.reduce(
      (prev, curr) => ((prev[curr] = ++prev[curr] || 1), prev),
      {}
    )
  }
  return count(rules.map(({ observed_field }) => observed_field))
}

const toReadableString = rules => {
  // get all observedFields and count them
  const counted = countObservedFields(rules)

  const strings = ["All"]

  if (counted.category) {
    const { enforced_value, comparison_operator } = rules.find(
      ({ observed_field }) => observed_field == "category"
    )
    strings.push(B(enforced_value))
  }

  // if (!counted.amount) strings.push("transactions")
  if (!counted.expense && !counted.revenue) strings.push("transactions")

  if (counted.revenue == 1 || counted.expense == 1) {
    strings.push(B(counted.revenue ? "revenues" : "expenses"))
    strings.push("that")

    const { enforced_value, comparison_operator } = rules.find(
      ({ observed_field }) =>
        observed_field == "revenue" || observed_field == "expense"
    )
    switch (comparison_operator) {
      case "=~":
        strings.push(B("contain"))
        break
      case "<":
        strings.push(B("are less than"))
        break
      case ">":
        strings.push(B("are greater than"))
        break
      case "=":
        strings.push(B("equal"))
        break
      default:
        strings.push("")
        break
    }
    strings.push(B(numeral(enforced_value).format("$0.00")))
  }

  // if 2 amounts:
  if (counted.revenue == 2 || counted.expense == 2) {
    const amounts = rules
      .filter(
        ({ observed_field }) =>
          observed_field == "revenue" || observed_field == "expense"
      )
      .map(({ enforced_value }) => numeral(enforced_value).value())
      .sort()
      .map(v => numeral(v).format("$0.00"))

    strings.push(B(counted.revenue ? "revenues" : "expenses"))

    strings.push("that", B("are between"), B(amounts[0]), "and", B(amounts[1]))
  }

  if (counted.merchant) {
    strings.push("from")
    const { enforced_value } = rules.find(
      ({ observed_field }) => observed_field == "merchant"
    )
    strings.push(B(enforced_value))
  }

  if (counted.day_of_week) {
    strings.push("on")
    const { enforced_value } = rules.find(
      ({ observed_field }) => observed_field == "day_of_week"
    )
    strings.push(B(enforced_value + "s"))
  }

  if (counted.date) {
    const { start_date, end_date } = rules.find(
      ({ observed_field }) => observed_field == "date"
    )
    const formattedRange = moment(start_date)
      .twix(end_date)
      .format({
        hideTime: true,
        monthFormat: "MMM",
        dayFormat: "Do"
      })
    strings.push("during", B(formattedRange))
  }

  if (counted.institution_account_token_id) {
    strings.push("for")
    const { enforced_value } = rules.find(
      ({ observed_field }) => observed_field == "institution_account_token_id"
    )
    // accountsFromInstitutionUsers()
    // strings.push(enforced_value)
  }

  return strings.join(" ")
}

export default toReadableString



// WEBPACK FOOTER //
// ./src/account/favorite-transactions/toReadableString.js